/**
 * Course-related models and interfaces
 */

export interface CourseSettingsData {
  // Upload Media
  files: File[];

  // Main Info
  discipline: string;
  audience: string;
  tone: string;
  /** Admin layout: course topic (cybersecurity focus, etc.). */
  topic?: string;

  // Structure
  quantity: string;
  duration: string;

  /** Admin VALVUR catalog: matches `CourseSettingsDto` (shared-grpc). */
  videoMainHeroName?: string;
  videoMainHeroDescription?: string;
  videoBackgroundHeroNames?: string[];

  /** School: request VALVUR source (gateway only applies for ADMIN/OWNER). */
  courseSource?: 'VALVUR' | 'TEACHER';
}

export interface StepperStep {
  id: string;
  label: string;
  icon: 'settings-dark' | 'ai' | 'edit-dark' | 'assign' | 'help' | 'delete';
  active?: boolean;
}

/** Default course creator flow (school / My courses). Override via `CourseCreatorComponent` `steps` input. */
export const DEFAULT_COURSE_CREATOR_STEPS: StepperStep[] = [
  {
    id: 'settings',
    label: 'app.components.courseCreator.settings.title',
    icon: 'settings-dark',
  },
  {
    id: 'generate',
    label: 'app.components.courseCreator.generate.title',
    icon: 'ai',
  },
  {
    id: 'publish',
    label: 'app.components.courseCreator.publish.title',
    icon: 'edit-dark',
  },
  {
    id: 'assign',
    label: 'app.components.courseCreator.assign.title',
    icon: 'assign',
  },
];
